angular.module('portal.i18n').constant('AvailableLanguages', [
    'en',
    'es',
    'de',
    'pt',
]);